import { ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface Props {
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const ContentContainer = ({ children, sx }: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', ...sx }}>
      {children}
    </Box>
  );
};

export default ContentContainer;
